import { types } from 'mobx-state-tree'
import {
  generateValueTypeWithLimits,
  generateEnumValue,
  generateEnumReferenceValue
} from 'src/api/models/Values/index'
import { Color } from 'src/api/misc/Color'
import { engravingColors, black } from 'src/constants/colors'
import {
  IRectangularProperties,
  ICircularProperties,
  IEngravingProperties
} from 'src/api/models/Elements/Element/ElementProperties/types'
import { CornerRadius } from './CornerRadius'
// const V = generateValueTypeWithLimits({
//   getRange: (self) => {
//     return { min: 0, max: Infinity }
//   }
// })

export const RectangularProperties: IRectangularProperties = types.model({
  width: types.optional(generateValueTypeWithLimits({}).named('Width'), {
    value: 5
  }),
  height: types.optional(generateValueTypeWithLimits({}).named('Height'), {
    value: 5
  }),
  cornerRadius: types.optional(CornerRadius, { value: 0 })
})

export const CircularProperties: ICircularProperties = types
  .model({
    radius: types.optional(generateValueTypeWithLimits({}).named('Radius'), {
      value: 5
    })
  })
  .views((self) => ({
    get width() {
      return { value: self.radius.value * 2 }
    },
    get height() {
      return { value: self.radius.value * 2 }
    }
  }))

export const EngravingProperties: IEngravingProperties = types.model(
  'EngravingProperties',
  {
    style: types.optional(
      generateEnumValue(['fill', 'stroke']).views(() => ({
        get type() {
          return 'select'
        }
      })),
      { value: 'stroke' }
    ),
    color: types.optional(
      generateEnumReferenceValue(
        Color as $FixMe,
        engravingColors,
        black,
        'EngravingColor',
        'name'
      ).views(() => ({
        // get options() {
        //   return engravingColors
        // },
        get type() {
          return 'select'
        }
      })),
      { value: black }
    ) //types.optional(types.maybe(types.reference(Color)), undefined)
  }
)
